import {
  PESQUISA_PRINCIPAL,
  PESQUISA_CORRELACAO,
  PESQUISA_ATIVO,
  PESQUISA_INDICADOR,
  PESQUISA_PESSOA,
  PESQUISA_PESSOA_FUNDO
} from '../const/servicesURI';
import requestService from './requestService';
import { httpRequests } from 'investira.sdk';
import utils from '../utils';

const cancel = {
  principal: null,
  correlacao: null,
  ativo: null,
  indicador: null,
  pessoa: null,
  pessoaFundo: null
};

export const principal = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.principal) {
    cancel.principal.cancel();
  }

  cancel.principal = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.principal.token
  };

  return requestService(xProps, PESQUISA_PRINCIPAL, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Principal');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const correlacao = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.correlacao) {
    cancel.correlacao.cancel();
  }

  cancel.correlacao = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.correlacao.token
  };

  return requestService(xProps, PESQUISA_CORRELACAO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Correlacao');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const ativo = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.ativo) {
    cancel.ativo.cancel();
  }

  cancel.ativo = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.ativo.token
  };

  return requestService(xProps, PESQUISA_ATIVO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Ativo');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const indicador = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.indicador) {
    cancel.indicador.cancel();
  }

  cancel.indicador = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.indicador.token
  };

  return requestService(xProps, PESQUISA_INDICADOR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Indicador');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const pessoa = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.pessoa) {
    cancel.pessoa.cancel();
  }

  cancel.pessoa = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.pessoa.token
  };

  return requestService(xProps, PESQUISA_PESSOA, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Pessoa');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const pessoaFundo = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.pessoaFundo) {
    cancel.pessoaFundo.cancel();
  }

  cancel.pessoaFundo = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.pessoaFundo.token
  };

  return requestService(xProps, PESQUISA_PESSOA_FUNDO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Pesquisa Pessoa Fundo');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const pesquisas = { principal, correlacao, ativo, indicador, pessoa, pessoaFundo, cancel };

export default pesquisas;
